import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Page } from '@templates'
import { formatCurrency, formatCurrencySemCifrao } from '@utils/masks'
import { StepRefin, TipoEmprestimo } from '@utils/enums'
import {
  setSolicitarContratacaoOrigin,
  trackingRefin,
} from '@store/refinanciamento/simulacao/actions'
import { Button } from '@interco/inter-ui/components/Button'
import { Separator, ColorWrapper, TextParagraph } from '@atoms'
import { ApplicationState } from '@store/types'
import { Colors } from '@utils/Colors'
import IcChevronUp from '@interco/icons/core/action-navigation/ic_chevron_up'
import IcChevronDown from '@interco/icons/core/action-navigation/ic_chevron_down'
import Tag from '@utils/Tag'
import routes from '@routes/routes'
import { BridgeService } from '@services/bridge'
import useTrackingRefin from '@hooks/useTrackingRefin'
import { dispatchRefinSolicitarContratacaoFlow } from '@utils/refinContratacaoFlow'

import { hasContratoCtps } from '../Contratos/helpers'
import { LineInfo } from './styles'
import Detalhes from './Detalhes'
import Parcelas from './Parcelas'

const ResultadoSimulacao = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [showBottomsheetParcelas, setShowBottomsheetParcelas] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { parcelaAtual, debtBalance, simulacaoSelecionada } = useSelector(
    (state: ApplicationState) => state.refinanciamento.simulacao,
  )
  const { contratosSelecionados } = useSelector(
    (state: ApplicationState) => state.refinanciamento.contratos,
  )
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)
  const loadingContratacao = useSelector(
    (state: ApplicationState) => state.refinanciamento.contratacao.loadingContratacao,
  )
  const convenioName = useSelector(
    (state: ApplicationState) => state.refinanciamento.contratos.convenioName,
  )
  const hasCtpsSelected = hasContratoCtps(contratosSelecionados)

  useTrackingRefin(StepRefin.RESULTADO_SIMULACAO)

  useEffect(() => {
    BridgeService.tac({
      name: 'resultado_simulacao',
      actions: [
        'continuar_refinanciamento',
        'continuar_refinanciamento_inss',
        'continuar_refinanciamento_ctps',
        'continuar_refinanciamento_siape',
        'simular_condicao_oferta_seguro',
        'autorizar_termo_inss',
      ],
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:result',
        ref_type: '',
        content_action: 'Dado carregado',
        action_id: 'Solicitar contratação',
        section: 'result',
        sub_section: '',
        step: '',
        scenario: 'Resultado da simulação',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'page_loaded',
        element_name: 'Solicitar contratação',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'payrollloan:refin:overview',
        section: 'overview',
        sub_section: '',
        step: '',
        scenario: 'Resultado da simulação',
      })
    }
  }, [isApp])

  const handleFAQClick = () => {
    navigate(routes.FAQ)
  }

  return (
    <Page
      stickyContainerFooterBottom="10px"
      positionFooter="sticky"
      titleHeader="Melhor condição"
      showRightIcon={hasCtpsSelected}
      rightIcon={hasCtpsSelected ? 'question-mark' : undefined}
      onRightButtonClick={hasCtpsSelected ? handleFAQClick : undefined}
      stickyFooter={
        <>
          <Separator margin="8px -24px" height="1px" />
          {showDetails ? (
            <>
              <div
                tabIndex={0}
                role="button"
                onKeyDown={() => {
                  setShowDetails(false)
                }}
                onClick={() => {
                  dispatch(trackingRefin(StepRefin.CLICK_RESULTADO_SIMULACAO_OCULTAR_DETALHES))
                  if (isApp) {
                    Tag.enviarTagueamentoApp({
                      screen: 'clt:refin:result',
                      ref_type: 'botao',
                      content_action: 'Toque',
                      action_id: 'Exibir menos detalhes',
                      section: 'result',
                      sub_section: '',
                      step: '',
                      scenario: 'Resultado da simulação',
                      ref_figma: '2',
                    })
                  } else {
                    Tag.enviarTagueamentoWeb({
                      element_action: 'click button',
                      element_name: 'Exibir menos detalhes',
                      c_page: window.location.href,
                      redirect_url: '',
                      section_name: 'payrollloan:refin:overview',
                      section: 'overview',
                      sub_section: '',
                      step: '',
                      scenario: 'Resultado da simulação',
                    })
                  }
                  setShowDetails(false)
                }}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignSelf: 'center',
                }}
              >
                <ColorWrapper fontWeight="700" color={Colors.PRIMARY500} margin="0 8px 0 0">
                  <TextParagraph variant="body-3">Exibir menos detalhes</TextParagraph>
                </ColorWrapper>
                <IcChevronDown width={24} height={24} color={Colors.PRIMARY500} />
              </div>
              <Detalhes />
            </>
          ) : (
            <div
              tabIndex={0}
              role="button"
              onKeyDown={() => {
                setShowDetails(true)
              }}
              onClick={() => {
                dispatch(trackingRefin(StepRefin.CLICK_RESULTADO_SIMULACAO_EXIBIR_DETALHES))
                if (isApp) {
                  Tag.enviarTagueamentoApp({
                    screen: 'clt:refin:result',
                    ref_type: 'botao',
                    content_action: 'Toque',
                    action_id: 'Exibir mais detalhes',
                    section: 'result',
                    sub_section: '',
                    step: '',
                    scenario: 'Resultado da simulação',
                    ref_figma: '2',
                  })
                } else {
                  Tag.enviarTagueamentoWeb({
                    element_action: 'click button',
                    element_name: 'Exibir mais detalhes',
                    c_page: window.location.href,
                    redirect_url: '',
                    section_name: 'payrollloan:refin:overview',
                    section: 'overview',
                    sub_section: '',
                    step: '',
                    scenario: 'Resultado da simulação',
                  })
                }
                setShowDetails(true)
              }}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignSelf: 'center',
              }}
            >
              <ColorWrapper fontWeight="700" color={Colors.PRIMARY500} margin="0 8px 0 0">
                <TextParagraph variant="body-3">Exibir mais detalhes</TextParagraph>
              </ColorWrapper>
              <IcChevronUp width={24} height={24} color={Colors.PRIMARY500} />
            </div>
          )}

          <Button
            fullWidth
            variant="primary"
            disabled={loadingContratacao || isSubmitting}
            isLoading={loadingContratacao || isSubmitting}
            onClick={async () => {
              dispatch(trackingRefin(StepRefin.CLICK_RESULTADO_SIMULACAO_SOLICITAR_CONTRATACAO))
              if (isSubmitting) return
              setIsSubmitting(true)

              BridgeService.tic({
                name: 'btn_solicitar_contratacao',
                action: 'solicitar_contratacao',
              })

              if (isApp) {
                Tag.enviarTagueamentoApp({
                  screen: 'clt:refin:result',
                  ref_type: 'botao',
                  content_action: 'Toque',
                  action_id: 'Solicitar contratação',
                  section: 'result',
                  sub_section: '',
                  step: '',
                  scenario: 'Resultado da simulação',
                  ref_figma: '2',
                })
              } else {
                Tag.enviarTagueamentoWeb({
                  element_action: 'click button',
                  element_name: 'Solicitar contratação',
                  c_page: window.location.href,
                  redirect_url: '',
                  section_name: 'payrollloan:refin:overview',
                  section: 'overview',
                  sub_section: '',
                  step: '',
                  scenario: 'Resultado da simulação',
                })
              }

              dispatch(setSolicitarContratacaoOrigin(true))

              dispatchRefinSolicitarContratacaoFlow(dispatch, {
                numberOfInstallments: parcelaAtual?.numberOfInstallments || 0,
                hasInsurance: simulacaoSelecionada === TipoEmprestimo.CREDITO_PROTEGIDO,
                convenioName,
                navigate,
                onComplete: () => setIsSubmitting(false),
                onError: () => setIsSubmitting(false),
              })
            }}
          >
            Solicitar contratação
          </Button>
        </>
      }
    >
      <ColorWrapper fontWeight="600">
        <TextParagraph variant="headline-h3" margin="24px 0 8px">
          Troco liberado pra você
        </TextParagraph>
      </ColorWrapper>
      <ColorWrapper color={Colors.SUCCESS500} fontWeight="600">
        <TextParagraph variant="headline-h3">
          {formatCurrency(parcelaAtual.availableAmount)}
        </TextParagraph>
      </ColorWrapper>
      <TextParagraph variant="caption-1">Esse valor cai direto na sua conta.</TextParagraph>
      <Separator variant="small" margin="24px 0" />
      <ColorWrapper color={Colors.GRAY500} fontWeight="600" margin="0">
        <TextParagraph variant="headline-h3">Suas novas parcelas</TextParagraph>
      </ColorWrapper>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <ColorWrapper fontWeight="700" color={Colors.PRIMARY500} margin="0">
            <TextParagraph variant="body-3">
              {`${parcelaAtual?.numberOfInstallments}x ${
                formatCurrency(parcelaAtual?.installmentAmount) === ''
                  ? 'R$ 0,00'
                  : formatCurrency(parcelaAtual?.installmentAmount)
              } ${
                simulacaoSelecionada === TipoEmprestimo.CREDITO_PROTEGIDO
                  ? 'com proteção'
                  : 'sem proteção'
              }`}
            </TextParagraph>
          </ColorWrapper>
          <TextParagraph variant="caption-2" margin="0px">
            Total de taxas e encargos (CET): {formatCurrencySemCifrao(parcelaAtual?.cETAa)}% a.a.
          </TextParagraph>
        </div>
        <ColorWrapper
          fontWeight="700"
          color={Colors.PRIMARY500}
          onClick={() => {
            dispatch(trackingRefin(StepRefin.CLICK_RESULTADO_SIMULACAO_ALTERAR_PARCELAS))
            if (isApp) {
              Tag.enviarTagueamentoApp({
                screen: 'clt:refin:result',
                ref_type: 'botao',
                content_action: 'Toque',
                action_id: 'Alterar',
                section: 'result',
                sub_section: '',
                step: '',
                scenario: 'Resultado da simulação',
                ref_figma: '2',
              })
            } else {
              Tag.enviarTagueamentoWeb({
                element_action: 'click button',
                element_name: 'Alterar',
                c_page: window.location.href,
                redirect_url: '',
                section_name: 'payrollloan:refin:overview',
                section: 'overview',
                sub_section: '',
                step: '',
                scenario: 'Resultado da simulação',
              })
            }
            setShowBottomsheetParcelas(true)
          }}
        >
          <TextParagraph variant="body-3">Alterar</TextParagraph>
        </ColorWrapper>
      </div>

      <Separator margin="32px -24px" height="8px" color={Colors.GRAY100} />

      <ColorWrapper color={Colors.GRAY500} fontWeight="600">
        <TextParagraph variant="headline-h3">Detalhes do refinanciamento</TextParagraph>
      </ColorWrapper>

      <TextParagraph variant="caption-1" margin="0 0 24px 0">
        Essa simulação é válida por 24 horas.
      </TextParagraph>

      <LineInfo>
        <TextParagraph variant="caption-1">Saldo devedor pré-refinanciamento</TextParagraph>
        <TextParagraph variant="caption-1" colorWeight={500} bold>
          {formatCurrency(debtBalance)}
        </TextParagraph>
      </LineInfo>
      <LineInfo>
        <TextParagraph variant="caption-1">Troco liberado</TextParagraph>
        <TextParagraph variant="caption-1" colorWeight={500} bold>
          {formatCurrency(parcelaAtual.availableAmount)}
        </TextParagraph>
      </LineInfo>
      <LineInfo>
        <TextParagraph variant="caption-1">Novo valor disponível</TextParagraph>
        <TextParagraph variant="caption-1" colorWeight={500} bold>
          {formatCurrency(parcelaAtual.requestedAmount)}
        </TextParagraph>
      </LineInfo>

      <Separator margin="8px 0 24px 0" height="1px" />

      <ColorWrapper color={Colors.GRAY500} fontWeight="700" margin="0 0 24px 0">
        <TextParagraph variant="body-3">Contratos selecionados</TextParagraph>
      </ColorWrapper>
      <>
        {contratosSelecionados?.map((contrato, index) => (
          <div key={`${contrato.numeroProposta}`}>
            {index !== 0 ? <Separator variant="small" margin="16px 0" /> : <></>}
            <LineInfo>
              <TextParagraph variant="caption-1">Valor da parcela:</TextParagraph>
              <TextParagraph variant="caption-1" colorWeight={500} bold>
                {formatCurrency(contrato.valorProximaParcela)}
              </TextParagraph>
            </LineInfo>
            <LineInfo style={{ marginBottom: '0px' }}>
              <TextParagraph variant="caption-1">Nº da proposta:</TextParagraph>
              <TextParagraph variant="caption-1" colorWeight={500} bold>
                {contrato.numeroProposta}
              </TextParagraph>
            </LineInfo>
          </div>
        ))}
      </>

      {showBottomsheetParcelas ? (
        <Parcelas setShowBottomsheetParcelas={setShowBottomsheetParcelas} />
      ) : (
        <></>
      )}
    </Page>
  )
}

export default ResultadoSimulacao
